import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CarOutlined } from '@ant-design/icons';

const icons = { CarOutlined };

// ==============================|| MENU ITEMS - TRAFFIC CITATIONS ||============================== //

const trafficCitations = {
    id: 'traffic_citations',
    title: <FormattedMessage id="trafficCitations" />,
    type: 'group',
    children: [
        {
            id: 'traffic-citations',
            title: <FormattedMessage id="trafficCitations" />,
            type: 'item',
            url: '/traffic-citations',
            icon: icons.CarOutlined
        }
    ]
};

export default trafficCitations;
